import Dexie from 'dexie';

const db = new Dexie('SavvyPlayer');
db.version(1).stores({
  videos:
    '++id,src,current,lastSavedAt,lessonId,materialId,userId,duration,initLoadTime,bufferCount,bufferPercent,seekCount,watchedTimeRanges',
});

export default db;
